import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowRight, Sun, Eyeglasses, Drop } from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const MAGASIN_2 = '/api/static/branding/magasin-2.jpg';

export const MrgCategoryTiles = ({ parentCats = [], goCategory, colors = {} }) => {
  const navigate = useNavigate();
  const primary = colors.primary || '#111111';
  const accent = colors.accent || '#FF004D';
  const [imgs, setImgs] = useState({});

  const find = (s) => (parentCats || []).find(c => (c.slug || '').includes(s));
  const soleil = find('soleil');
  const vue = find('vue');
  const lentille = find('lentille');

  useEffect(() => {
    const cats = [soleil, vue, lentille].filter(Boolean);
    if (!cats.length) return;
    Promise.all(cats.map(c =>
      axios.get(`${API_URL}/api/s/mrg/products?category=${c.id}&limit=1`)
        .then(r => [c.id, r.data?.products?.[0]?.featured_image || null])
        .catch(() => [c.id, null])
    )).then(pairs => setImgs(Object.fromEntries(pairs)));
  }, [soleil, vue, lentille]);

  const tiles = [
    soleil && { key: 'soleil', title: 'Lunettes de soleil', sub: 'Toutes nos solaires', img: imgs[soleil.id], fit: 'contain', icon: <Sun size={20} weight="fill" />, onClick: () => goCategory(soleil.id), large: true },
    vue && { key: 'vue', title: 'Lunettes de vue', sub: 'Montures optiques', img: imgs[vue.id], fit: 'contain', icon: <Eyeglasses size={20} weight="fill" />, onClick: () => goCategory(vue.id) },
    lentille && { key: 'lentille', title: 'Lentilles', sub: 'Contact', img: imgs[lentille.id] || MAGASIN_2, fit: imgs[lentille.id] ? 'contain' : 'cover', icon: <Drop size={20} weight="fill" />, onClick: () => goCategory(lentille.id) },
  ].filter(Boolean);

  return (
    <section className="py-16 md:py-20 bg-white" data-testid="mrg-category-tiles">
      <div className="max-w-[1320px] mx-auto px-6">
        <div className="text-center mb-10">
          <span className="text-[12px] font-semibold uppercase tracking-[0.25em]" style={{ color: accent }}>Nos univers</span>
          <h2 className="text-[30px] md:text-[42px] font-semibold text-slate-900 leading-tight mt-1" style={{ fontFamily: "'Poppins', sans-serif" }}>Que recherchez-vous&nbsp;?</h2>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {tiles.map(t => (
            <button key={t.key} onClick={t.onClick}
              className={`group relative overflow-hidden rounded-3xl text-left ${t.large ? 'col-span-2 lg:col-span-2' : ''}`}
              style={{ minHeight: 260, backgroundColor: t.fit === 'contain' ? '#f4f4f6' : '#111' }} data-testid={`tile-${t.key}`}>
              {t.img && (
                <img src={t.img} alt={t.title}
                  className={`absolute inset-0 w-full h-full ${t.fit === 'contain' ? 'object-contain p-8' : 'object-cover'} group-hover:scale-105 transition-transform duration-[1.2s] ease-out`}
                  loading="lazy" />
              )}
              <div className="absolute inset-x-0 bottom-0 h-2/3" style={{ background: `linear-gradient(180deg, transparent 0%, ${primary}E6 78%)` }} />
              <div className="absolute inset-0 p-5 md:p-6 flex flex-col justify-end">
                <span className="inline-flex w-10 h-10 rounded-full items-center justify-center mb-3 text-white" style={{ backgroundColor: accent }}>{t.icon}</span>
                <h3 className="text-white text-[19px] md:text-[23px] font-semibold leading-tight" style={{ fontFamily: "'Poppins', sans-serif" }}>{t.title}</h3>
                <span className="text-white/70 text-[13px] mt-0.5">{t.sub}</span>
                <span className="mt-3 inline-flex items-center gap-1.5 text-[13px] font-semibold opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all" style={{ color: '#fff' }}>
                  Découvrir <ArrowRight size={15} weight="bold" />
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MrgCategoryTiles;
